import { useSelector } from "react-redux";
import { useMemo } from "react";

const useUtilsUnit = (options = {}) => {
  const { userData: includeUserData = false, loginTimestamp: includeLoginTimestamp = false } = options;

  // Individual useSelector calls for better performance
  const userData = useSelector((state) => state.user.userData);
  const loginTimestamp = useSelector((state) => state.user.loginTimestamp);

  return useMemo(() => {
    return {
      userData: includeUserData ? userData : null,
      loginTimestamp: includeLoginTimestamp ? loginTimestamp : null,
    };
  }, [userData, loginTimestamp, includeUserData, includeLoginTimestamp]);
};

export default useUtilsUnit;
